import { Minimize2, X } from 'lucide-react'
import { useI18n } from '../../i18n'
import { DefendSphereAiConversation } from './DefendSphereAiConversation'
import { useDefendSphereAi } from './DefendSphereAiProvider'
import './defendsphere-ai.css'

export function DefendSphereAiWorkspace() {
  const { conversation, collapseToPanel, close } = useDefendSphereAi()
  const { t } = useI18n()

  return (
    <div
      id="ds-ai-workspace"
      className="ds-ai-workspace"
      role="dialog"
      aria-modal="true"
      aria-label={t('complianceCenterUi.defendSphereAi.workspaceTitle', 'DefendSphere AI Workspace')}
    >
      <header className="ds-ai-workspace__header">
        <div>
          <h2 className="ds-ai-workspace__title">
            {t('complianceCenterUi.defendSphereAi.workspaceTitle', 'DefendSphere AI Workspace')}
          </h2>
          <p className="ds-ai-workspace__subtitle">
            {t(
              'complianceCenterUi.defendSphereAi.defaultExperience',
              'DefendSphere AI — AI CISO. Ask about risks, assets, vulnerabilities, evidence, controls, and suppliers.',
            )}
          </p>
        </div>
        <div className="ds-ai-workspace__actions">
          <button
            type="button"
            className="ds-ai-icon-btn"
            aria-label={t('complianceCenterUi.defendSphereAi.collapseToPanel', 'Collapse to side panel')}
            onClick={collapseToPanel}
          >
            <Minimize2 aria-hidden />
          </button>
          <button
            type="button"
            className="ds-ai-icon-btn"
            aria-label={t('complianceCenterUi.defendSphereAi.closePanel', 'Close AI panel')}
            onClick={() => {
              if (conversation.pendingDisclosure?.required && conversation.disclosureBusy) return
              close()
            }}
          >
            <X aria-hidden />
          </button>
        </div>
      </header>
      <div className="ds-ai-workspace__body">
        <DefendSphereAiConversation api={conversation} t={t} showHistory />
      </div>
    </div>
  )
}
